<template>
    <div class="row space-around">
        <div class="col-45" :class="{'wrap': wrap}">
            <div @click="$emit('update:modelValue', button1)" class="btn-primary d-block w-100 text-center h-100">
                <div v-if="button1.icon">
                    <img :src="button1.icon" class="responsive-w-100"/>
                </div>
                <div :class="{boldText: bold}">
                    {{ button1.label }}
                </div>
            </div>
        </div>
        <div class="col-45" :class="{'wrap': wrap}">
            <div  @click="$emit('update:modelValue', button2)" class="btn-primary d-block w-100 text-center h-100">
                <div v-if="button2.icon">
                    <img :src="button2.icon" class="responsive-w-100"/>
                </div>
                <div :class="{boldText: bold}">
                    {{ button2.label }}
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        button1: Object,
        button2: Object,
        bold:{
            type:Boolean,
            default:false
        },
        wrap:{
            type:Boolean,
            default:false
        },
    }
}
</script>
<style scoped>
.responsive-w-100{
    width:70%;
}
.boldText{
    color: var(--text-color);
    font-family: var(--font);
    font-size: 32px;
    font-style: normal;
    font-weight: 900;
    line-height: 33.2px; /* 103.75% */
}
@media screen and (max-width: 1000px) {
    .responsive-w-100{
        width:100%;
    }
    .boldText{
        font-size: 20px;
    }
}
@media screen and (max-width: 600px) {
    .wrap{
        width:100%;
        margin-bottom: 20px;
    }
    .responsive-w-100{
        width:50%;
    }

}
</style>